import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CustomItinerary from "../pages/custom-itinerary/page";
import DestinationPage from "../pages/destination/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/custom-itinerary",
    element: <CustomItinerary />,
  },
  {
    path: "/destination/:id",
    element: <DestinationPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
